import cms from '../apis/cms';
import auth from '../apis/auth';

async function renovarSessao(): Promise<string> {
  try {
    const storageRefreshToken = localStorage.getItem('@Internal:refresh_token');
    const storageAcessToken = localStorage.getItem('@Internal:token');
    const storageUser: any = localStorage.getItem('@Internal:user');

    if (!storageRefreshToken) {
      throw Error('Refresh token não encontrado');
    }

    if (!storageAcessToken) {
      throw Error('Token não encontrado');
    }

    if (!storageUser) {
      throw Error('Usuário não encontrado');
    }

    const { data }: any = await auth.post('auth/refresh-token', {
      refresh_token: storageRefreshToken,
      userId: JSON.parse(storageUser)?.id,
      access_token: storageAcessToken,
    });

    if (!data?.access_token) {
      throw Error('Renovação de sessão não retornou um token válido');
    }

    localStorage.setItem('@Internal:refresh_token', data.refresh_token);
    localStorage.setItem('@Internal:token', data.access_token);

    auth.defaults.headers.common.authorization = `Bearer ${data.access_token}`;
    cms.rest.defaults.headers.common.authorization = `Bearer ${data.access_token}`;

    return data.access_token;
  } catch (err) {
    localStorage.clear();
    delete auth.defaults.headers.common.authorization;
    delete cms.rest.defaults.headers.common.authorization;
    window.location.href = '/auth';
    throw err;
  }
}

let renovacaoEmAndamento: Promise<string> | null = null;

// Evita disparar renovações em paralelo: REST, GraphQL e o interceptor de src/apis/auth.ts
// podem cair em 401 ao mesmo tempo, e o refresh token do yggdrasil é de uso único — duas
// chamadas concorrentes fariam a 2ª "gastar" um token já consumido pela 1ª, derrubando uma
// sessão que tinha acabado de ficar válida de novo.
export default function refreshToken(): Promise<string> {
  if (!renovacaoEmAndamento) {
    renovacaoEmAndamento = renovarSessao().finally(() => {
      renovacaoEmAndamento = null;
    });
  }
  return renovacaoEmAndamento;
}
